import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { SUB_LINK, CONTROLS } from "../../shapes"
import "./style.scss"
import FactorTypeSelector from "modules/factor-category-selector"
import BaseSelector from "components/base-selector"
import SubLink from "./sublink"
import ModelSelector from "modules/model-selector"
import { DATE } from "helpers/shapes"

class Subnav extends Component {
  static propTypes = {
    subLinks: PropTypes.arrayOf(SUB_LINK).isRequired,
    modelId: PropTypes.string.isRequired,
    modelName: PropTypes.string.isRequired,
    portfolioBenchmark: PropTypes.object.isRequired,
    controls: CONTROLS.isRequired,
    isActiveViewType: PropTypes.bool.isRequired,
    selectedBase: PropTypes.object,
    setSelectedBase: PropTypes.func.isRequired,
    searchValue: PropTypes.string,
    baseInputFocus: PropTypes.func.isRequired,
    baseHistory: PropTypes.array.isRequired,
    searchResults: PropTypes.array.isRequired,
    baseInputBlur: PropTypes.func.isRequired,
    baseSearch: PropTypes.func.isRequired,
    baseDropdownVisible: PropTypes.bool.isRequired,
    defaultSelectedBase: PropTypes.object.isRequired,
    setModel: PropTypes.func.isRequired,
    modifiedScreens: PropTypes.array.isRequired,
    openDialog: PropTypes.func.isRequired,
    openCompositeSecurity: PropTypes.func.isRequired,
    portfolioId: PropTypes.string.isRequired,
    noRestrictionModels: PropTypes.array.isRequired,
    portfolioDates: PropTypes.shape({
      earliest: DATE,
      latest: DATE,
    }),
    modelSupportsComposites: PropTypes.bool.isRequired,
    unsupportedCurrencyWarning: PropTypes.string,
  }

  render() {
    const {
      subLinks,
      controls,
      modelId,
      modelName,
      portfolioBenchmark,
      isActiveViewType,
      selectedBase,
      setSelectedBase,
      searchValue,
      baseInputFocus,
      baseHistory,
      searchResults,
      baseInputBlur,
      baseSearch,
      baseDropdownVisible,
      defaultSelectedBase,
      setModel,
      modifiedScreens,
      portfolioId,
      noRestrictionModels,
      portfolioDates,
      modelSupportsComposites,
      unsupportedCurrencyWarning,
      openCompositeSecurity,
    } = this.props

    return <div className="subnav">
      <div className="left">
        {map(subLinks, link =>
          <SubLink key={link.id} {...link} />,
        )}
      </div>
      <div className="right">
        <div className="model-base-info">
          <ModelSelector
            noSpinner
            modelId={modelId}
            modelName={modelName}
            setModel={setModel}
            modifiedScreens={modifiedScreens}
            resourceType="portfolio"
            resourceId={portfolioId}
            noRestrictionModels={noRestrictionModels}
            disableUnderline
            assetAvailability={portfolioDates}
            warningMessage={unsupportedCurrencyWarning}
          />
          {controls.viewTypeSelector
            && <BaseSelector
              modelId={modelId}
              active={isActiveViewType}
              portfolioBenchmark={portfolioBenchmark}
              selectedBase={selectedBase}
              setSelectedBase={setSelectedBase}
              searchValue={searchValue}
              baseInputFocus={baseInputFocus}
              baseDropdownVisible={baseDropdownVisible}
              baseHistory={baseHistory}
              searchResults={searchResults}
              baseInputBlur={baseInputBlur}
              baseSearch={baseSearch}
              defaultSelectedBase={defaultSelectedBase}
              modelSupportsComposites={modelSupportsComposites}
              openCompositeSecurity={openCompositeSecurity}
              useDefaultActiveBenchmarkSelector={false}
            />}
        </div>
        {controls.factorTypeSelector && <FactorTypeSelector />}
      </div>
    </div>
  }
}

export default Subnav
